import styled from "styled-components";
import type { ICloseButtonProps } from "./types";

export const ModalOverlay = styled.div<{ $hidden?: boolean }>`
  position: fixed;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;

  inset: 0;

  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);

  /* visibility, not display: none — the modal stays laid out and mounted
     (scroll position, form state, everything) while something portaled
     elsewhere covers the screen instead. See IModalProps.hidden. */
  ${({ $hidden }) =>
    $hidden &&
    `
    visibility: hidden;
    pointer-events: none;
  `}
`;

export const ModalBox = styled.div`
  position: relative;
  min-width: fit-content;
  max-width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 0.5rem;
`;

export const CloseButton = styled.div<ICloseButtonProps>`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 35px;
  height: 35px;
  z-index: 100000;
  color: black;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0; /* Prevents button from shrinking */

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  img,
  svg {
    width: 20px;
    height: 20px;
    display: block;
    color: #555;
  }
`;
